import VueScrollTo from 'vue-scrollto'

export default {
    install(Vue) {
        Vue.mixin({
            methods: {
                scrollToError(formErrors) {
                    if (formErrors === undefined) return;
                    if (formErrors.items.length > 0) {
                        if (formErrors.items[0].field === '') {
                            return;
                        }

                        let el = this.$el.querySelector('[data-vv-name="'+formErrors.items[0].field+'"]');

                        if (el !== null) {
                            VueScrollTo.scrollTo(el, 700, {
                                offset: -100,
                            });
                        }
                    }
                },
            }
        })
    }
}